// Manage new sign ups via 3P integrations
export const MANAGE_3P_INTEGRATION_SIGNUP_REQUEST = 'manage_3p_integration_signup_request';
export const MANAGE_3P_INTEGRATION_SIGNUP_SUCCESS = 'manage_3p_integration_signup_success';
export const MANAGE_3P_INTEGRATION_SIGNUP_FAILURE = 'manage_3p_integration_signup_failure';
export const MANAGE_3P_INTEGRATION_SIGNUP_RESET = 'manage_3p_integration_signup_failure';